<mat-dialog-content>
    <div fxLayout="row wrap" fxLayoutAlign="center" fxLayoutGap="12px">
        <div class="calendar-size">
            <mat-calendar #calendar (selectedChange)="select($event,calendar)"
                           [dateClass]="isSelected" [(selected)]="today"></mat-calendar>
            <p><small><strong>Note: Dates marked on calendar are approved vacation start and end dates.</strong></small></p>
        </div>
        <mat-table [dataSource]="dateEmployees" matSort matTableFilter>
            <ng-container *ngFor="let field of fieldNames;let i=index"  matColumnDef="{{field}}">
                <th id="header" mat-header-cell mat-sort-header="{{field}}" *matHeaderCellDef class="mat-column-headers-standard">
                    {{displayNames[i]}}
                </th>
                <td mat-cell *matCellDef="let employee" class="mat-column-standard">
                    <div *ngIf="field == 'absenceType' || field == 'requestStatus'">
                        {{employee[field] | titlecase | removeUnderscorePipe}}
                    </div>
                    <div *ngIf="field !== 'absenceType' && field !== 'requestStatus'">
                        {{employee[field]}}
                    </div>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="fieldNames; sticky: true;"></tr>
            <tr mat-row *matRowDef="let row = row; let even = even; columns: fieldNames;"
                [ngClass]="{blueBackground : even}"></tr>
        </mat-table>
    </div>
    <button mat-raised-button color="primary" (click)="close()">Close</button>
</mat-dialog-content>
<fab-loading-spinner *ngIf="!isLoading" #calendar></fab-loading-spinner>
